import { GetLeakStatus, ILeakPoint, IPipeDiameter } from "@/api/types"
import { formatDate } from "."
import * as XLSX from 'xlsx-js-style'

export function leaks2DetailExcel(leaks: ILeakPoint[]) {

    const wb = XLSX.utils.book_new()
    wb.Workbook = {
        Views: [{ RTL: false }],
        Sheets: [{ Hidden: 0 }]
    }

    const ws = XLSX.utils.aoa_to_sheet([])
    XLSX.utils.book_append_sheet(wb, ws, '漏点明细数据')

    // 定义样式
    const titleStyle = {
        font: { sz: 25, bold: true, name: "宋体" },
        alignment: { horizontal: "center", vertical: "center" }
    }

    const statisticsStyle = {
        font: { sz: 11, name: "宋体" },
        alignment: { horizontal: "left", vertical: "center" }
    }

    const headerStyle = {
        font: { sz: 12, bold: true, name: "宋体" },
        alignment: { horizontal: "center", vertical: "center" },
        border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" }
        },
        fill: { // 添加表头背景色
            fgColor: { rgb: "EEEEEE" }
        }
    }

    const dataStyle = {
        font: { sz: 10, name: "宋体" },
        alignment: { horizontal: "center", vertical: "center" },
        border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" }
        }
    }

    const addressStyle = {
        font: { sz: 10, name: "宋体" },
        alignment: { horizontal: "left", vertical: "center" },
        border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" }
        }
    }

    // 设置列宽
    ws['!cols'] = [
        { wch: 20 },
        { wch: 100 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
    ]

    // 确定表格总列数
    const totalColumns = 8;

    const titleRow = ['市政供水管线暗漏点排查明细表']
    const statisticsRow =  ['总计：' + leaks.length + '个']
    const headerRow = ['编号', '地址', '口径', '管材', '漏量(m³/h)', '路面', '发现时间', '漏点状态']

    // 添加标题行
    XLSX.utils.sheet_add_aoa(ws, [titleRow], { origin: 'A1' })

    // 合并标题行的单元格从A1到H1
    ws['!merges'] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: totalColumns - 1 } }
    ]

    // 应用标题样式
    const titleCell = XLSX.utils.encode_cell({ r: 0, c: 0 });
    if (!ws[titleCell].s) ws[titleCell].s = {};
    ws[titleCell].s = titleStyle;

    // 添加统计行
    XLSX.utils.sheet_add_aoa(ws, [statisticsRow], { origin: 'A2' })

    // 合并统计行单元格
    ws['!merges'].push(
        { s: { r: 1, c: 0 }, e: { r: 1, c: totalColumns - 1 } }
    )

    // 应用统计行样式
    const statisticsCell = XLSX.utils.encode_cell({ r: 1, c: 0 });
    if (!ws[statisticsCell].s) ws[statisticsCell].s = {};
    ws[statisticsCell].s = statisticsStyle;

    // 添加表头行
    XLSX.utils.sheet_add_aoa(ws, [headerRow], { origin: 'A3' })

    // 为表头行的每个单元格应用样式
    for (let i = 0; i < headerRow.length; i++) {
        const cellRef = XLSX.utils.encode_cell({ r: 2, c: i });
        if (!ws[cellRef]) ws[cellRef] = { v: headerRow[i] };
        if (!ws[cellRef].s) ws[cellRef].s = {};
        ws[cellRef].s = headerStyle;
    }

    // 准备数据
    const excelData = leaks.map((leak) => {
        return [
            leak.index,
            leak.detection?.detailAddr || leak.detection?.referenceAddr || '',
            leak.repair?.size || leak.detection?.size || '',
            leak.repair?.material || leak.detection?.material || '',
            leak.repair?.leakLeakage || '',
            leak.repair?.roadInfo || leak.detection?.roadInfo || '',
            formatDate(leak.createTime, 'YYYY/MM/DD'),
            GetLeakStatus(leak.leakStatus)
        ]
    })

    // 添加数据行（不含表头）
    XLSX.utils.sheet_add_aoa(ws, excelData, { origin: 'A4' })

    // 为所有数据单元格应用样式
    for (let i = 0; i < excelData.length; i++) {
        for (let j = 0; j < headerRow.length; j++) {
            const cellRef = XLSX.utils.encode_cell({ r: i + 3, c: j });
            if (!ws[cellRef]) ws[cellRef] = {};

            // 对地址列使用特殊的左对齐样式
            if (j === 1) {
                ws[cellRef].s = addressStyle;
            } else {
                ws[cellRef].s = dataStyle;
            }
        }
    }

    // 设置行高
    ws['!rows'] = [
        { hpt: 40 }, // 标题行高
        { hpt: 25 }, // 统计行高
        { hpt: 30 }, // 表头行高
    ];

    // 为所有数据行设置行高
    for (let i = 0; i < excelData.length; i++) {
        ws['!rows'][i + 3] = { hpt: 30 }; // 数据行高
    }

    return wb
}

export function leaks2RepairSummaryExcel(leaks: ILeakPoint[], sizeInfo: IPipeDiameter[]) {
    const wb = XLSX.utils.book_new()
    wb.Workbook = {
        Views: [{ RTL: false }],
        Sheets: [{ Hidden: 0 }]
    }

    const ws = XLSX.utils.aoa_to_sheet([])
    XLSX.utils.book_append_sheet(wb, ws, '漏点维修结算表')

    const titleRow = ['市政供水管线暗漏点维修结算表'] // A - G列

    const signatureRow = ['时间：_______ 年 _______ 月 _______ 日', '签字：__________'] // B - C列 空D列 E-G列
    const headerRow = ['序号', '编号', '地址', '管径', '单价', '管材', '漏量(m³/h)']

    // 定义样式
    const titleStyle = {
        font: { sz: 26, bold: true, name: "宋体" },
        alignment: { horizontal: "center", vertical: "center" }
    }

    const signatureStyle = {
        font: { sz: 11, name: "宋体" },
        alignment: { horizontal: "left", vertical: "bottom" }
    }

    const totalPriceStyle = {
        font: { sz: 11, bold: true, name: "宋体" },
        alignment: { horizontal: "left", vertical: "bottom" }
    }

    const headerStyle = {
        font: { sz: 14, bold: true, name: "宋体" },
        alignment: { horizontal: "center", vertical: "center" },
        border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" }
        },
        fill: { // 添加表头背景色
            fgColor: { rgb: "EEEEEE" }
        }
    }

    const dataStyle = {
        font: { sz: 11, name: "宋体" },
        alignment: { horizontal: "center", vertical: "center" },
        border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" }
        }
    }

    const addressStyle = {
        font: { sz: 11, name: "宋体" },
        alignment: { horizontal: "left", vertical: "center" },
        border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" }
        }
    }

    let index = 0
    let totalPrice = 0
    let price = 0

    // 准备Excel数据
    const excelData = leaks.map((leak) => {
        index ++
        // price = sizeInfo.find(
        //     (size) => size.size === leak.repair?.size)?.price || sizeInfo.find(
        //         (size) => size.size === leak.detection?.size)?.price || 0,
        price = leak.repair?.sizePrice || leak.detection?.sizePrice || 0
        totalPrice += price
        return [
            index,
            leak.index,
            leak.detection?.detailAddr || leak.detection?.referenceAddr || '',
            leak.repair?.size || leak.detection?.size || '',
            price,
            leak.repair?.material || leak.detection?.material || '',
            leak.repair?.leakLeakage || ''
        ]
    })

    const totalPriceRow = ['总金额：￥:' + totalPrice] // A-C列

    // 设置列宽
    ws['!cols'] = [
        { wch: 15 },  // 序号
        { wch: 20 },  // 编号
        { wch: 100 }, // 地址
        { wch: 20 },  // 管径
        { wch: 20 },  // 单价
        { wch: 20 },  // 管材
        { wch: 20 },  // 漏量
    ];

    // 确定表格总列数
    const totalColumns = 7; // 从A到G共7列

    // 添加标题行
    XLSX.utils.sheet_add_aoa(ws, [titleRow], { origin: 'A1' });

    // 合并标题行单元格从A1到G1
    ws['!merges'] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: totalColumns - 1 } }
    ];

    // 应用标题样式
    const titleCell = XLSX.utils.encode_cell({ r: 0, c: 0 });
    if (!ws[titleCell].s) ws[titleCell].s = {};
    ws[titleCell].s = titleStyle;

    // 添加签名行（放在第二行）
    const signatureRowPos = 1; // 第二行

    // 添加"时间"部分
    XLSX.utils.sheet_add_aoa(ws, [[signatureRow[0]]], { origin: `B${signatureRowPos + 1}` });

    // 合并时间单元格从B到C
    ws['!merges'].push(
        { s: { r: signatureRowPos, c: 1 }, e: { r: signatureRowPos, c: 2 } }
    );

    // 应用签名样式
    const timeSignCellRef = XLSX.utils.encode_cell({ r: signatureRowPos, c: 1 });
    if (!ws[timeSignCellRef].s) ws[timeSignCellRef].s = {};
    ws[timeSignCellRef].s = signatureStyle;

    // 添加"签字"部分
    XLSX.utils.sheet_add_aoa(ws, [[signatureRow[1]]], { origin: `E${signatureRowPos + 1}` });

    // 合并签字单元格从E到G
    ws['!merges'].push(
        { s: { r: signatureRowPos, c: 4 }, e: { r: signatureRowPos, c: 6 } }
    );

    // 应用签名样式
    const nameSignCellRef = XLSX.utils.encode_cell({ r: signatureRowPos, c: 4 });
    if (!ws[nameSignCellRef].s) ws[nameSignCellRef].s = {};
    ws[nameSignCellRef].s = signatureStyle;

    // 添加总金额行（第三行）
    const totalPriceRowPos = 2; // 第三行
    XLSX.utils.sheet_add_aoa(ws, [totalPriceRow], { origin: `A${totalPriceRowPos + 1}` });

    // 合并总金额行单元格从A到C
    ws['!merges'].push(
        { s: { r: totalPriceRowPos, c: 0 }, e: { r: totalPriceRowPos, c: 2 } }
    );

    // 应用总金额样式
    const totalPriceCellRef = XLSX.utils.encode_cell({ r: totalPriceRowPos, c: 0 });
    if (!ws[totalPriceCellRef].s) ws[totalPriceCellRef].s = {};
    ws[totalPriceCellRef].s = totalPriceStyle;

    // 添加表头行（第四行）
    XLSX.utils.sheet_add_aoa(ws, [headerRow], { origin: 'A4' });

    // 为表头行的每个单元格应用样式
    for (let i = 0; i < headerRow.length; i++) {
        const cellRef = XLSX.utils.encode_cell({ r: 3, c: i });
        if (!ws[cellRef]) ws[cellRef] = { v: headerRow[i] };
        if (!ws[cellRef].s) ws[cellRef].s = {};
        ws[cellRef].s = headerStyle;
    }

    // 添加数据行（从第五行开始）
    XLSX.utils.sheet_add_aoa(ws, excelData, { origin: 'A5' });

    // 为所有数据单元格应用样式
    for (let i = 0; i < excelData.length; i++) {
        for (let j = 0; j < headerRow.length; j++) {
            const cellRef = XLSX.utils.encode_cell({ r: i + 4, c: j });
            if (!ws[cellRef]) ws[cellRef] = {};

            // 对地址列使用特殊的左对齐样式
            if (j === 2) {
                ws[cellRef].s = addressStyle;
            } else {
                ws[cellRef].s = dataStyle;
            }
        }
    }

    // 计算总行数（标题1行 + 表头1行 + 数据n行）
    const totalRows = 2 + excelData.length;

    // 设置行高
    ws['!rows'] = [
        { hpt: 40 },  // 标题行高
        { hpt: 30 },  // 签字行高
        { hpt: 20 },  // 总金额行高
    ];

    // 为所有数据行设置行高
    for (let i = 0; i < excelData.length + 1; i++) {
        ws['!rows'][i + 3] = { hpt: 30 }; // 数据行高，比表头稍矮一点
    }

    return wb
}
